import { createAction } from '@reduxjs/toolkit';

import { SubjectPropertyDetailsFormOutput } from '../../../modules/orderDetails/schemas.ts';

export const submitEditSubjectPropertyDetailsForm = createAction<SubjectPropertyDetailsFormOutput>(
  'submitEditSubjectPropertyDetailsForm',
);
